/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Shortcut_Keys_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed importing shortcuts with error: {error}" |
*
* @param {Shortcut_Keys_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_import_failed_toast = /** @type {((inputs: Shortcut_Keys_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de l'import des raccourcis : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Importieren der Verknüpfungen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare i collegamenti con errore: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать ярлыки с ошибкой: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar accesos directos con el error: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入快捷方式失败，错误信息：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ショートカットのインポートに失敗しました。エラー: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शॉर्टकट आयात करने में त्रुटि आई: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar atalhos com o erro: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed importing shortcuts with error: ${i?.error}`)
});